import Container from './styled';

export default Container;
